import script from "./BoldIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BoldIcon.vue?vue&type=script&setup=true&lang=js"

export default script